export const HEADER_DATA = {
  overlay: {
    products: [
      {
        title: 'Kompakte Schnelllader',
        img: {
          sm: '/content/content-images/landingpages/anker/header/03f01c71798bc5442b72c37b18ea22f5/anker-30w-usb-c-nano-4-ladegeraet.png',
          md: '/content/content-images/landingpages/anker/header/1497ecd9b3aa2913069c37ea73cb78dc/anker-30w-usb-c-nano-4-ladegeraet@2x.png',
        },
        imgStyle: {
          '--aspect-ratio': '1 / 1',
        },
        anchor: {
          type: 'nano',
        },
      },
      {
        title: 'Multi-Charger',
        img: {
          sm: '/content/content-images/landingpages/anker/header/2a7071fee904891f3a8fff9dd5204e88/header-navi-thumb-multi-charger.png',
          md: '/content/content-images/landingpages/anker/header/da7f2e56bf502051f80a252f1893c3a6/header-navi-thumb-multi-charger@2x.png',
        },
        imgStyle: {
          '--aspect-ratio': '142 / 111',
        },
        anchor: {
          type: 'ganprime',
        },
      },
      {
        title: 'Kabellose Ladegeräte',
        img: {
          sm: '/content/content-images/landingpages/anker/header/a84106ee8c8c4e20aebb8ffddaff09fd/anker-3-in-1-cube-magsafe.png',
          md: '/content/content-images/landingpages/anker/header/63ebda8edeadee29fd48705adec7d802/anker-3-in-1-cube-magsafe@2x.png',
        },
        imgStyle: {
          '--aspect-ratio': '67 / 64',
        },
        anchor: '#kabellose-ladegeraete',
      },
      // {
      //   title: 'Kabel & Adapter',
      //   img: {
      //     sm: '/content/content-images/landingpages/anker/header/91c29c30391f1701e4b44b6c0bd534b5/header-navi-thumb-kabel-adapter.png',
      //     md: '/content/content-images/landingpages/anker/header/8c482276b41551ff23f319089d712eca/header-navi-thumb-kabel-adapter@2x.png',
      //   },
      //   imgStyle: {
      //     '--aspect-ratio': '134 / 111',
      //   },
      //   anchor: '#anker__banner-kabel',
      //   lazy: true,
      // },
      {
        title: 'Powerbanks',
        img: {
          sm: '/content/content-images/landingpages/anker/header/f52c056236366477e3a9990c10001087/header-navi-thumb-ladepads.png',
          md: '/content/content-images/landingpages/anker/header/f58d1d2c4f70ed994da1190678a14bdc/header-navi-thumb-ladepads@2x.png',
        },
        imgStyle: {
          maxWidth: '125px',
          minWidth: '125px',
          '--aspect-ratio': '38 / 41',
        },
        anchor: {
          action: 'external_link',
          url: '/zubehoer?search=anker-powerbank',
        },
        lazy: true,
      },
    ],
  },
};

export const PRODUCT_TEASER_DATA = [
  {
    articleNumber: '99935130',
    title: 'Anker 30W USB-C Nano 4 Ladegerät',
    copy: '<ul class="anker-list"><li>3x schnelleres Laden</li><li>Extrem kompaktes Design</li><li>Ladeschutz mit ActiveShield 2.0</li></ul>',
    video: {
      poster:
        '/_ipx/f_webp,w_640/content/content-images/landingpages/anker/7e53b976bf5e8e7a61f432113cae15f6/hero-teaser-nano-4-charger-fallback@2x.jpg',
      src: '/content/content-videos/landingpages/anker/4d51aae827d5275f8086616b0fcd319a/nano-lader.webm',
      id: 'nano',
    },
    type: 'nano',
    tileGroups: ['highlight'],
  },
  {
    articleNumber: '99934043',
    title: 'Anker 65W GaN Prime 3-Port Netzteil',
    copy: '<ul class="anker-list"><li>30 Minuten schnelleres Laden</li><li>53% kleiner als andere Ladegeräte</li><li>3 Geräte gleichzeitig laden</li><li>Ladeschutz mit ActiveShield 2.0</li></ul>',
    video: {
      poster:
        '/_ipx/f_webp,w_640/content/content-images/landingpages/anker/557c4d8704fc6039ffef0c80fd0c1501/hero-teaser-gan-prime-charger@2x.jpg',
      src: '/content/content-videos/landingpages/anker/a551c26bcfb2eaf071a239682bef5b19/gan-lader.webm',
      id: 'ganprime',
    },
    type: 'ganprime',
    tileGroups: ['highlight'],
  },
  {
    articleNumber: '99935131',
    title: 'Anker 30W USB-C Nano 4 Ladegerät',
    copy: 'Umweltfreundliches Laden',
    tileGroups: ['first'],
  },
  {
    articleNumber: '99935133',
    title: 'Anker Bio-Based USB-C auf USB-C Kabel 180 cm',
    copy: 'Bio & belastbar',
    tileGroups: ['first'],
  },

  {
    articleNumber: '99935135',
    title: 'Anker 30W Nano Powerbank 10.000 mAh',
    copy: 'Integriertes USB-C Kabel',
    tileGroups: ['first'],
  },
  {
    articleNumber: '848061055764',
    title: 'Anker 312 Wireless Charger (Stand)',
    copy: '10% schneller als vergleichbare Ladegeräte',
    tileGroups: ['first'],
  },
  {
    articleNumber: '194644034153',
    title: 'Anker PowerExpand USB-C auf Dual HDMI Adapter',
    copy: 'Mache USB-C Ports zu dualen HDMI-Eingängen – ganz ohne Installation. Einfach anschließen – fertig.',
    tileGroups: ['first'],
  },
  {
    articleNumber: '848061039238',
    title: 'Anker 337 Power Bank (PowerCore 26K)',
    copy: 'Schnellstes Laden für drei Geräte gleichzeitig',
    tileGroups: ['first'],
  },
  {
    articleNumber: '194644092504',
    title: 'Anker 337 Power Bank (PowerCore 26K)',
    copy: 'ENORME KAPAZITÄT: 25,600mAh',
    tileGroups: ['first'],
  },
  {
    articleNumber: '194644097059',
    title: 'Anker 337 Power Bank (PowerCore 26K)',
    copy: 'ZUVERLÄSSIGE POWER: Ausgestattet mit einer Kapazität von 20.000 mAh',
    tileGroups: ['first'],
  },
  {
    articleNumber: '848061026603',
    title: 'Anker 337 Power Bank (PowerCore 26K)',
    copy: 'EINER FÜR ALLE: Kompatibel mit all Deinen USB-Geräten!',
    tileGroups: ['first'],
  },
  {
    articleNumber: '0194644098018OT',
    stageContent: {
      heading: 'Anker 3-in-1 Ladewürfel mit MagSafe ',
      subheading: 'Ein kompakter Kraftprotz für deine Apple-Geräte ',
      copy: 'Lade dein iPhone, deine AirPods und deine Apple Watch gleichzeitig und kabellos mit dem Anker 3-in-1 Ladewürfel mit MagSafe. Dieses kompakte und tragbare Ladegerät ist die perfekte Lösung für alle, die ihre Apple-Geräte unterwegs aufladen möchten.<br><br>Die MagSafe-Technologie sorgt dafür, dass dein iPhone sicher auf dem Ladegerät fixiert ist und nicht versehentlich herunterfällt.',
    },
    localImage:
      '/content/content-images/landingpages/anker/outdoor-stage/bec0b3b5ad263c44ea45a1a758c928dd/anker-3-in-1-magsafe-ladewuerfel@2x.png',
    aspectRatio: '287 / 303',
    tileGroups: ['outdoor-stage'],
  },
  {
    articleNumber: '99934045',
    stageContent: {
      heading: 'Anker 622 Magnetische Powerbank Mag-Go 5000&nbsp;mAh',
      subheading: 'Kabellose Energie für noch mehr Mobilität',
      copy: 'Anker 622 Magnetische Powerbank Mag-Go 5000 mAh Ein kompakter Kraftprotz für Ihre Geräte Laden Sie Ihr Smartphone oder andere Geräte mehrmals und kabellos mit der Anker 622 Magnetischen Powerbank Mag-Go 5000 mAh auf. Dieses kompakte und tragbare Ladegerät ist die perfekte Lösung für alle, die ihre Geräte unterwegs aufladen möchten.<br><br>Die magnetische Technologie sorgt dafür, dass Ihr Gerät sicher auf der Powerbank fixiert ist und nicht versehentlich herunterfällt. Einfach anklippen und schon beginnt der Ladevorgang. Kein Kabelsalat, keine Suche nach der Steckdose.',
    },
    tileGroups: ['outdoor-stage'],
  },
  {
    articleNumber: '194644115203',
    tileGroups: ['second'],
  },
  {
    articleNumber: '194644098636',
    tileGroups: ['third'],
  },
  {
    articleNumber: '194644115197',
    tileGroups: ['third'],
  },
  {
    articleNumber: '194644098810',
    tileGroups: ['third'],
  },
];

export const NAVIGATION_DATA = [
  {
    type: 'nano',
    title: 'Nano Serie',
    description: 'Das beste für jedes iPhone und viele weitere Geräte',
    img: {
      sm: '/content/content-images/landingpages/anker/navigation/ad927cd529a2aff52cd72c8a3b2ab2cb/anker-30w-usb-c-nano-4-ladegeraet-hero.png',
      md: '/content/content-images/landingpages/anker/navigation/7fbe76bd372252d7eb30c15c457e5144/anker-30w-usb-c-nano-4-ladegeraet-hero@2x.png',
    },
    product: {
      name: 'Anker 511 Charger (Nano 3, 30W)',
      subtitle: 'Anker Nano. Bestes iPhone-Ladegeräte. ',
      spec: [
        {
          name: 'Abmessungen',
          value: '46 × 29 × 73 mm (ohne Ladezinken)',
        },
        {
          name: 'Gewicht',
          value: '45g',
        },
        {
          name: 'Lieferumfang',
          value: '30W USB-C Ladegerät Bedienungsanleitung',
        },
        {
          name: 'Ausgangsleistung (Watt)',
          value: 'Gesamtleistung: 30W',
        },
      ],
    },
    articleNumber: '194644095079',
    tileGroups: ['navigation'],
  },
  {
    type: 'ganprime',
    title: 'GaNPrime™ Serie',
    description: 'Die beste Multi-Geräte-Ladeserie',
    img: {
      sm: '/content/content-images/landingpages/anker/navigation/93f536b13feef47a10af8acaa22cfe55/nav-schnelllader-gan-prime.png',
      md: '/content/content-images/landingpages/anker/navigation/50f18f5808c7d8a1b1379a44bb0f3bad/nav-schnelllader-gan-prime@2x.png',
    },
    articleNumber: '194644087432',
    tileGroups: ['navigation'],
  },
];
